var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"constructing-page"},[_c('div',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("404")]),_c('div',{staticStyle:{"margin-left":"20px","color":"rgb(52, 78, 117)"}},[_vm._v("Page not found!")])])
}]

export { render, staticRenderFns }